import React from 'react'
import clsx from 'clsx'
import { isNaN } from 'lodash'
import { makeStyles } from '@mui/styles'
import { formatCurrency } from '@/modules/_helpers/formatCurrency'
import PropTypes from 'prop-types'

const EMPTY_PROP = '-'

export const CurrencyAmountCell = (props) => {
  const classes = useStyles()
  const { value, colorful = false, className } = props

  const getColorClass = () => {
    const parsedValue = parseFloat(value)

    if (!colorful || isNaN(parsedValue)) return {}

    return parsedValue > 0 ? classes.positive : classes.negative
  }

  const formattedValue = formatCurrency(value) || EMPTY_PROP

  return (
    <div className={clsx(classes.main, getColorClass(), className)}>{formattedValue}</div>
  )
}

const useStyles = makeStyles((theme) => ({
  main: {
    textAlign: 'left',
  },
  positive: {
    color: theme.green,
  },
  negative: {
    color: theme.red,
  },
}))

CurrencyAmountCell.propTypes = {
  value: PropTypes.any,
  colorful: PropTypes.bool,
  customClass: PropTypes.string,
}

CurrencyAmountCell.defaultProps = {
  colorful: false,
}

export default CurrencyAmountCell
